// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3D93f","large":"styles_large__2pvf_"};